// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7TjdV","chartContainer":"styles_chartContainer__dO8rz","legendWrapper":"styles_legendWrapper__uWCfI","legendItem":"styles_legendItem__d2tjI"};